<template>
  <div
    class="content grow"
    :class="'content-' + content.side"
    :style="{
      'background-image': 'url(' + content.thumbnail + ')',
      'background-size': 'cover',
      'background-position': 'center',
    }"
  >
    <router-link
      :class="'content-' + content.side"
      :to="'./' + content.genre + '/' + content.side + content.index"
    >
      <header>
        {{ content.side[0].toUpperCase() + content.side.slice(1) }} - No.{{
          content.index
        }}
      </header>
      <body>
        <p>
          <b>{{ content.title }}</b>
        </p>
      </body>
      <footer>
        <p>
          <b>{{ content.artist }}</b>
        </p>
      </footer>
    </router-link>
    <like-button :content="content"></like-button>
  </div>
</template>

<script>
import "hover.css";
import LikeButton from "./LikeButton.vue";

export default {
  components: { LikeButton },
  name: "qvf-content",
  conponents: {
    LikeButton,
  },
  props: {
    content: {
      type: Object,
      default: undefined,
    },
  },
  methods: {
    // $emitで親コンポーネントにv-on:content-clickイベントの通知
    onclick: function() {
      this.$emit("content-click");
    },
  },
  mounted: function() {
    this.$el.style.animationDelay = `${20 * this.content.index}ms`; //indexの値に応じてアニメーション遅延
  },
  updated: function() {},
};
</script>

<style scoped lang="scss">
a {
  text-decoration: none;
}

.content {
  margin: 2%;
  padding: 10px;
  width: 40%;
  height: 200px;
  border-radius: 5px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    border-radius: inherit;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  &:hover {
    cursor: pointer;
  }
  @media (max-width: 1000px) {
    margin: 4%;
    padding: 6%;
    width: 80%;
    height: 160px;
  }
}

.content-neutral {
  background-color: rgba(100, 100, 100, 1);
  color: rgba(255, 255, 255, 0.85);
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.5);
  &::after {
    background: linear-gradient(
      rgba(0, 0, 0, 0.9) 0%,
      rgba(0, 0, 0, 0.4) 20%,
      rgba(0, 0, 0, 0.4) 80%,
      rgba(0, 0, 0, 0.9) 100%
    );
  }
}

.content-dark {
  background-color: rgba(0, 0, 0, 1);
  color: rgba(255, 255, 255, 0.85);
  box-shadow: 1px 1px 5px 0 rgba(255, 255, 255, 0.5);

  // 文字が見にくいので少し濃くした
  &::after {
    background: linear-gradient(
      rgba(0, 0, 0, 0.9) 0%,
      rgba(0, 0, 0, 0.5) 20%,
      rgba(0, 0, 0, 0.5) 80%,
      rgba(0, 0, 0, 0.9) 100%
    );
  }
}

.content-light {
  background-color: rgba(255, 255, 255, 1);
  color: rgba(0, 0, 0, 0.85);
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.5);
  // 文字が見にくいので少し濃くした
  &::after {
    background: linear-gradient(
      rgba(255, 255, 255, 0.9) 0%,
      rgba(255, 255, 255, 0.5) 20%,
      rgba(255, 255, 255, 0.5) 80%,
      rgba(255, 255, 255, 0.9) 100%
    );
  }
}

header {
  position: relative;
  z-index: 1;
  font-size: 1em;
  height: 18%;
  line-height: 200%;
}

body {
  position: relative;
  z-index: 1;
  margin: 0%;
  height: 60%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    font-size: 2em;
    max-width: 100%;
    max-height: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    @media (max-width: 800px) {
      font-size: 1.5em;
    }
  }
}

footer {
  position: relative;
  z-index: 1;
  p {
    font-size: 1.2em;
    height: 28%;
    line-height: 300%;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    @media (max-width: 1000px) {
      font-size: 1em;
    }
  }
}
@mixin hideTapHighlightColor() {
  //Prevent highlight colour when element is tapped
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

@mixin hardwareAccel() {
  //Improve performance on mobile/tablet devices
  transform: translateZ(0);
}

@mixin improveAntiAlias() {
  //Improve aliasing on mobile/tablet devices
  // box-shadow: 0 0 1px rgba(0, 0, 0, 0);
}
.grow {
  transition-duration: 0.2s;
  transition-property: transform;

  @include hideTapHighlightColor();
  @include hardwareAccel();
  @include improveAntiAlias();

  &:hover {
    transform: scale(1.05);
  }
}
</style>
